/**
 * Text repeat — pure, deterministic text repetition.
 * Safe to render server-side.
 */

export const MAX_COUNT = 10000;

export interface RepeatOptions {
  /** Joins each repetition (default newline). */
  separator?: string;
  /** Prefix each repetition with "1. ", "2. ", … */
  addNumbering?: boolean;
  /** Trim the final joined result. */
  trimResult?: boolean;
}

/** Clamp a requested count to a safe integer in [1, MAX_COUNT]. */
export function clampCount(n: number): number {
  if (!Number.isFinite(n)) return 1;
  return Math.max(1, Math.min(MAX_COUNT, Math.floor(n)));
}

export function repeatText(
  text: string,
  count: number,
  opts: RepeatOptions = {},
): string {
  const sep = opts.separator ?? "\n";
  const n = clampCount(count);
  const parts: string[] = [];
  for (let i = 0; i < n; i++) {
    parts.push(opts.addNumbering ? `${i + 1}. ${text}` : text);
  }
  const result = parts.join(sep);
  return opts.trimResult ? result.trim() : result;
}
